<template>
  <transition name="slide-fade">
    <div>
      <div id="homeHeader" style="">
        <div class="container" >
          <header>
            <div class="row">
              <div class="col-md-8 mb-2 order-1 order-md-0">
                <h1 class="page-header">
                  <span v-if="user && user.guardian">Welcome to {{ user.firstName}}'s Account!</span>
                  <span v-else-if="user">Welcome {{ user.firstName }}!</span>
                </h1>
              </div>
              <div class="col-md-4 text-md-right text-left order-0 order-md-1">
                <img src="static/Microba-Logo-White.png" style="height:50px;">
              </div>
              <div class="col-12 order-2">
                <div class="page-description mb-4" >
                  This is the Microba Research Portal where you can keep track of your Microba Research Kits. Depending on the research project you are a part of, you may also use this portal to complete questionnaires and view your report. You can navigate to different areas by clicking on the appropriate icon in the navigation bar. Thank you for being an active contributor to advancing scientific discoveries together with Microba and its research partners.
                </div>
              </div>
            </div>
          </header>
        </div>
      </div>
      <div class="dashboard" v-if="dashboard && user">
        <div class="container" >
          <div class="row padded-row">
            <div class="col-md-4 col-12 mb-4">

              <div class="mb-3 btn-card-background">
                <router-link :to="'kits'" class="btn-card grey" href="#" @click.prevent="showOrderModal = true">
                  <div>
                    <i data-v-a48edea6="" class="fas fa-hdd"></i>
                    View your research projects
                  </div>
                </router-link>
              </div>
              <div class="mb-3 btn-card-background">
                <a @click.prevent="redeemCode" class="btn-card purple" href="">
                  <div>
                    <i data-v-a48edea6="" class="icon-dashboard"></i>
                    Activate a new kit
                  </div>
                </a>
              </div>
              <div class="btn-card-background">
                <a @click.prevent="addProject" class="btn-card green" href="">
                  <div>
                    <i class="icon-plus"></i>
                    Add a new project
                  </div>
                </a>
              </div>
            </div>
            <div class="col-12 col-md-8 mb-4">
              <div id="notifications" class="card">
                <div class="card-body row notificationBox">
                  <div class="col-12">
                    <h4 v-show="getKits && getKitNotifications.length > 0" class="pb-2 dashboardSubtitle">Notifications</h4>
                    <template v-for="notification in getKitNotifications">

                        <div class="mb-2 row notificationRow">
                          <div class="col-12 col-lg-2 col-md-4">
                            <strong v-if="notification.name" class="limitText">{{ notification.name }}</strong>
                            <strong v-else>KIT-{{ notification.kitId }}</strong>
                          </div>
                          <div class="col-12 col-lg-8 col-md-6">
                            <span>{{ notification.statusText }}</span>
                          </div>
                          <div class="col-12 col-lg-2 col-md-2 text-lerft text-md-right"><strong><router-link :to="{ name: 'Your kits' }">view</router-link></strong></div>
                        </div>

                    </template>


                    <template v-if="getKitNotifications && getKitNotifications.length < 1">
                      <div class="row">
                        <div class="col-12 text-center">
                          No notifications to display at present.
                        </div>
                      </div>
                    </template>


                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <ModalAddProject
          :show="showAddProjectModal"
          @close="showAddProjectModal = false"
          @activateKit="onClickActivate"
        ></ModalAddProject>
        <ModalRedeemKit
          :show="showRedeemKitModal"
          :showIntro="showIntro"
          :setProject="firstProject"
          @close="showRedeemKitModal = false; showIntro = false"
          @activateKit="onClickActivate"
        ></ModalRedeemKit>

        <ModalActivate :kitID="selectedKit" :show="showActivateModal" @close="showActivateModal = false" />



      </div>
    </div>
  </transition>
</template>

<script>
  import ModalAddProject from '@/application/research/models/ModalAddProject'
  import ModalRedeemKit from '@/application/research/models/ModalRedeemKit'
  import ModalActivate from '@/application/research/models/ModalActivate'
  import WidgetAction from '@/components/widgets/WidgetAction'
  import WidgetAdd from '@/components/widgets/WidgetAdd'
  import WidgetMyKits from '@/components/widgets/widget-my-kits'
  import UserMixins from '@/mixins/userProfile'
  import _ from 'lodash'

  export default {
    name: 'Dashboard',
    components: {
      WidgetAdd,
      WidgetAction,
      WidgetMyKits,
      ModalAddProject,
      ModalRedeemKit,
      ModalActivate
    },
    mixins: [ UserMixins ],
    mounted: function () {
      let self = this
      this.$store.dispatch('getUser').then(success => {
        if (this.dashboard.profileCompleted) {
          let redeemObj = localStorage.getItem('redeem_on_register')
          if (redeemObj) {
            localStorage.removeItem('redeem_on_register')
            self.joinProject(JSON.parse(redeemObj))
          }
        }
      })
      this.$store.dispatch('getDashboard')
      this.$store.dispatch('getResearchKits').then(success => {
        self.checkUnassignedKit()
      })

      if (this.$route.query.showModal && this.$route.query.showModal === 'REDEEM') {
        this.showIntro = true
        this.showRedeemKitModal = true
      }
    },
    data: function () {
      return {
        showAddProjectModal: false,
        showRedeemKitModal: false,
        showActivateModal: false,
        showPurchaseModal: false,
        showRedeemModal: false,
        showCoachInfoModal: false,
        showIntro: false,
        firstProject: null,
        activatePage: '',
        selectedKit: '',
        selectedProject: '',
        additionalKit: {
          amount: Number(process.env.PRICE_NEW_KIT) || 419.00,
          label: '1 Microba insight kit',
          orderType: 'NEW'
        }
      }
    },
    computed: {
      getKitNotifications () {
        if (!this.getKits || this.getKits.length < 1) return []

        let statuses = []
        for (var proj = 0; proj < this.getKits.length; proj++) {
          for (var kit = 0; kit < this.getKits[proj]['kits'].length; kit++) {
            let statusText = this.getKitStatus(this.getKits[proj]['logisticType'], this.getKits[proj]['kits'][kit]['sampleStatus'], this.getKits[proj]['kits'][kit]['kitStatus'])

            if (statusText) {
              statuses.push({
                sampleIdentifier: this.getKits[proj]['kits'][kit]['sampleIdentifier'],
                kitId: this.getKits[proj]['kits'][kit]['id'],
                name: this.getKits[proj]['kits'][kit]['name'],
                projectName: this.getKits[proj]['name'],
                logisticType: this.getKits[proj]['logisticType'],
                kitStatus: this.getKits[proj]['kits'][kit]['kitStatus'],
                sampleStatus: this.getKits[proj]['kits'][kit]['sampleStatus'],
                statusText: statusText
              })
            }
          }
        }

        return _.take(statuses, 7)
      },
      availableKits: function () {
        const myKits = []
        for (var kitId in this.getKits) {
          let thisKit = this.getKits[kitId]
          if (thisKit.sampleStatus === 'RESULTS_AVAILABLE' || thisKit.sampleStatus === 'MICROBIOME_COACH_SESSION_COMPLETED') {
            myKits.push(thisKit)
          }
        }
        return myKits
      },
      activatedKits: function () {
        const myKits = []
        for (var kitId in this.getKits) {
          let thisKit = this.getKits[kitId]
          if (thisKit.kitStatus !== 'UNASSIGNED') {
            myKits.push(thisKit)
          }
        }
        return myKits
      },
      coachKits: function () {
        const myKits = []
        for (var kitId in this.getKits) {
          let thisKit = this.getKits[kitId]
          if (thisKit.sampleStatus === 'MICROBIOME_COACH_SESSION_COMPLETED') {
            myKits.push(thisKit)
          }
        }
        return myKits
      },
      dashboard: function () {
        return this.$store.state.GET_DASHBOARD_RESPONSE || {}
      },
      totalKits: function () {
        if (!this.dashboard) return 0
        return this.dashboard.numberOfUnassignedKits + this.dashboard.numberOfRedeemedKits
      },
      unasignedKits: function () {
        if (!this.dashboard) return 0
        return this.dashboard.numberOfUnassignedKits
      },
      user: function () {
        return this.$store.state.GET_USER_RESPONSE
      },
      getKits: function () {
        return this.$store.state.GET_KITS_RESPONSE
      },
      enableSurveys: function () {
        // return true
        return process.env.ENABLE_SURVEYS === 'true' || false // .env by default are strings
      },
      mmStatus () {
        return {
          REQUESTED: 'Preparing your order',
          DISPATCHED: 'Your kit has been dispatched',
          RECEIVED_BY_LAB: 'Sample received by Microba'
        }
      },
      cmStatus () {
        return {
          REQUESTED: 'Preparing your order',
          DISPATCHED: 'Sampling',
          RECEIVED_BY_LAB: 'Sample received by Microba'
        }
      }
    },
    methods: {
      getKitStatus (type, sampleStatus, kitStatus) {
        if (type === 'MICROBA_MANAGED') {
          return this.mmStatus[sampleStatus] || this.mmStatus[kitStatus] || false
        }
        return this.cmStatus[sampleStatus] || this.cmStatus[kitStatus] || false
      },
      addProject () {
        this.showAddProjectModal = true
      },
      redeemCode () {
        this.showRedeemKitModal = true
      },
      showRedeem () {
        this.activatePage = 'REDEEM_CODE_WITH_ADDRESS'
        this.showRedeemModal = true
      },
      hasQuestionnaries (project, kit) {
        return project.exerciseSurveyEnabled || project.foodSurveyEnabled || project.medicalSurveyEnabled || project.mentalSurveyEnabled || project.samplingSurveyEnabled
      },
      checkUnassignedKit () {
        let self = this

        if (!self.getKits) return

        if (!self.showRedeemModal) return
        for (let proj = 0; proj <= self.getKits.length; proj++) {
          if (self.getKits && self.getKits[proj] && self.getKits[proj]['kits']) {
            for (let kit = 0; kit <= self.getKits[proj]['kits'].length; kit++) {
              if (self.getKits[proj]['kits'][kit]['kitStatus'] === 'ASSIGNED') {
                self.onClickActivate(self.getKits[proj]['kits'][kit]['id'])
                return
              }
            }
          }
        }
      },
      onClickActivate: function (kitID) {
        console.log(kitID)
        this.selectedKit = kitID
        this.showActivateModal = true
      },
      joinProject (obj) {
        const payload = {
          'participantIdentifier': obj.participantIdentifier,
          'userId': this.user.id
        }
        // let self = this

        this.$store.dispatch('joinResearch', payload).then(success => {
          console.log('Project', success)
          this.firstProject = success.data
          // self.redeemVoucher(obj)
          // alert('Redeem voucher')
          this.$store.dispatch('getResearchKits').then(success => {
            this.redeemCode()
          })
        }).catch(error => {
          console.log('ERROR', error)
        })
      },
      // redeemVoucher (obj) {
      //   let self = this
      //   const payload = {
      //     voucher: obj.voucherCode
      //   }
      //   this.$store.dispatch('checkVoucher', payload).then(success => {
      //     // self.selectedKit = success.data
      //     console.log('KIT', success.data)
      //     self.processRedeem(success.data, obj)
      //   }).catch(error => {
      //     console.log('ERROR', error)
      //     self.error = 'You have entered an invalid voucher code. Please check the code or contact your project administrator.'
      //   })
      // },
      processRedeem (kit, obj) {
        const payload = {
          kitId: kit.id,
          addressLine1: '',
          addressLine2: '',
          suburb: '',
          state: '',
          postcode: '',
          voucher: obj.voucherCode,
          activate: false
        }
        let self = this

        this.$store.dispatch('redeemKitBasic', payload).then(success => {
          self.$store.dispatch('getResearchKits')
          self.checkUnassignedKit()
        }).catch(error => {
          console.log('ERROR', error)
        })
      }
    },
    watch: {
      dashboard: function (dash) {
        // Redirect to profule if not complete
        if (this.dashboard.profileCompleted === false) {
          this.$bus.$emit('disableSidebar')
          this.$router.push('/profile')
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



  .chart-wrap {
    position: relative;
    height: 200px;
    margin: 50px auto;
  }

  em {
    font-size: 17px;
    opacity: 0.7;
    max-width: 500px;
    margin: 0px auto;
  }
  .padded-row {
    padding-bottom:0;
    @media (min-width:992px) {
      padding-bottom:1rem;
    }
  }

  .mb-4 {
    margin-bottom: 1.25rem !important;
    @media (min-width:992px) {
      margin-bottom: 1.5rem !important;
    }
  }



  .dashboard {
    //padding-bottom:2.5rem;
    padding-bottom:100px;
  }

  #homeHeader{
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#8873b6+0,5396ca+100 */
    background: #8873b6; /* Old browsers */
    background: -moz-linear-gradient(left, #8873b6 0%, #5396ca 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, #8873b6 0%,#5396ca 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, #8873b6 0%,#5396ca 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    background: url('~@/assets/images/bg-dashboard-img.jpg') no-repeat;
    background-size: cover;
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8873b6', endColorstr='#5396ca',GradientType=1 ); /* IE6-9 */

    padding:4rem 0;
    margin-bottom:2rem;

  }
  #homeHeader span{
    color:#fff;
  }
  #homeHeader .page-description{
    color:#fff
  }

  .btn-outline-secondary{
    border-color:#fff;
    color:#fff;
  }
  .btn-outline-secondary:hover{
    background-color:#fff;
    color:#000;
  }
  .buy-buttons .list-group-item{
    background: #eee;
  }


  .notificationRow{
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
    background:#eee;
    padding:15px;
  }

  .dashboard{
    margin-top:-100px;
  }

  .dashboardSubtitle{
    height: 21px;
    width: 231px;
    color: #00193D;
    font-family: Roboto;
    font-size: 18px;
    font-weight: 500;
    line-height: 21px;
  }

  .card-kit {
    height: 180px;
    border-radius: 4px;
    background-color: #F4F4F4;
    border: 0px;

    .title{
      font-size: 42px;
      font-weight: 300;
      line-height: 22px;
      text-align: center;
      margin-top:25px;
      margin-bottom:30px;
      margin-left:20px;
      width:100%;
    }
    .titleInner{
      display:inline-block;
      color: #818A97;
      font-size: 22px;
      font-weight: 300;
      line-height: 22px;
      margin-left:20px;
      text-align:right;
      margin-top:10px;
    }

    .status{
      color: #00193D;
      font-size: 16px;
      font-weight: 300;
      line-height: 22px;
      text-align: center;
    }

    a{
      margin-top:10px;
      display:block;
      font-size: 16px;
      font-style: italic;
      font-weight: 500;
      line-height: 22px;
      text-align: center;
    }
  }

  #notifications{
    .card-body{
      min-height:305px;
    }
  }

  .limitText {
    display: block;
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .notificationBox{
    min-height: 466px !important;
  }

  .btn-card i {
    font-size:28px;
  }

</style>



// WEBPACK FOOTER //
// src/application/research/Dashboard.vue